module.exports = __webpack_public_path__ + "static/media/dividend-payments.d4e38d01.svg";